export const formatMessageTimestamp = (isoString) => {
  const now = new Date();
  const msgDate = new Date(isoString);

  const isToday =
    now.toDateString() === msgDate.toDateString();

  const yesterday = new Date(now);
  yesterday.setDate(yesterday.getDate() - 1);
  const isYesterday =
    yesterday.toDateString() === msgDate.toDateString();

  if (isToday) {
    return msgDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }

  if (isYesterday) {
    return 'Yesterday';
  }

  const isThisYear = now.getFullYear() === msgDate.getFullYear();

  if (isThisYear) {
    return msgDate.toLocaleDateString(undefined, {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
    });
  }

  return msgDate.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};
